import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconMoveDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.5625 14.5586L3.96875 9.96484C3.69531 9.71875 3.69531 9.30859 3.96875 9.03516C4.21484 8.78906 4.625 8.78906 4.89844 9.03516L8.37109 12.5078V4.40625C8.37109 4.05078 8.64453 3.75 9.02734 3.75C9.38281 3.75 9.68359 4.05078 9.68359 4.40625V12.5078L13.1562 9.03516C13.4023 8.78906 13.8125 8.78906 14.0586 9.03516C14.332 9.28125 14.332 9.71875 14.0586 9.96484L9.46484 14.5586C9.21875 14.8047 8.80859 14.8047 8.5625 14.5586Z",
		fill: "#868686"
	})
});
export default SvgIconMoveDown;
